<template>
  <v-card id="allergy-list" class="mb-5 pt-5">
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="options"
      :server-items-length="meta.total"
      @click:row="onRowClick"
    >
      <template v-slot:top></template>

      <template v-slot:item.date="{ item }">
        <div>{{ item.date }}</div>
        <div v-if="item.time">{{ item.time }}</div>
        <div v-if="item.who">{{ item.who }}</div>
      </template>

      <template v-slot:item.group="{ item }">
        {{ item.fields.find(field => field.field_id === 293) ? item.fields.find(field => field.field_id === 293).value : "-" }}
      </template>

      <template v-slot:item.type="{}"> Предсменный/предрейсовый </template>

      <template v-slot:item.employee="{ item }">
        <Employee :data="item.employee" />

        <div class="row mt-1">
          <div v-for="attach in buildPreviewUrls(item.attachments)" :key="attach.id" class="col-4">
            <AuthImage width="90px" :path="attach.path" />
          </div>
        </div>
      </template>

      <template v-slot:item.conclusion="{ item }">
        {{ item.fields.find(field => field.field_id === 252) ? item.fields.find(field => field.field_id === 252).value : "-" }}
      </template>

      <template v-slot:item.temperature="{ item }">
        <!--<Values :data="item.fields" />-->
        {{ item.fields.find(field => field.field_id === 247) ? item.fields.find(field => field.field_id === 247).value : "-" }}
      </template>

      <template v-slot:item.pulse="{ item }">
        {{ item.fields.find(field => field.field_id === 246) ? item.fields.find(field => field.field_id === 246).value : "-" }}
      </template>

      <template v-slot:item.pressuresys="{ item }">
        {{ item.fields.find(field => field.field_id === 244) ? item.fields.find(field => field.field_id === 244).value : "-" }}
      </template>

      <template v-slot:item.pressuredia="{ item }">
        {{ item.fields.find(field => field.field_id === 245) ? item.fields.find(field => field.field_id === 245).value : "-" }}
      </template>

      <template v-slot:item.ethanol="{ item }">
        {{ item.fields.find(field => field.field_id === 248) ? item.fields.find(field => field.field_id === 248).value : "-" }}
      </template>

      <template v-slot:item.doctor_sign="{ item }">
        <div class="d-flex flex-column">
          <v-btn
            v-if="item.status && item.status.value !== '1'"
            small
            class="mb-3"
            color="primary"
            @click.prevent.stop="allowToWork(item)"
          >
            Допустить
          </v-btn>

          <v-btn small disabled v-if="item.doctor_sign">Подписан</v-btn>
          <v-btn small v-else @click.stop="signItem(item)">Подписать</v-btn>
        </div>
      </template>
      <!--      <template v-slot:item.result="{ item }">-->
      <!--        <Result :data="item.result" />-->
      <!--      </template>-->
    </v-data-table>
  </v-card>
</template>

<script>
import DateRangePicker from "@/components/forms/DateRangePicker";
import Employee from "./Employee";
import Values from "./Values";
import Result from "./Result";
import SignDocument from "@/modules/documents/add-document/SignDocument.vue";
import { QueryHelper } from "@/services/query-helper.js";
import { CustomerService } from "@/services/api/customer.service";
import { FLAGS } from "@/configs";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";
import AuthImage from "@/components/AuthImage.vue";
import imageExtList from "@/services/image-extensions.js";
import { buildDocumentUrl } from "@/services/utils.js";

export default {
  name: "List",
  components: { AuthImage, DateRangePicker, Employee, Values, Result },

  data: () => ({
    loading: false,
    options: {},
    filter: {},
    headers: [
      // { text: "МО/Сессия", value: "id", align: "start", sortable: false },
      { text: "Дата, время", value: "date", align: "start", sortable: false },
      { text: "Терминал", value: "group", align: "center", sortable: false },
      // { text: "Тип контроля / модель", value: "type", align: "start", sortable: false },
      { text: "Сотрудник", value: "employee", align: "start", sortable: false },
      { text: "Заключение", value: "conclusion", align: "start", sortable: false },
      { text: "Температура", value: "temperature", align: "start", sortable: false },
      { text: "Пульс", value: "pulse", align: "start", sortable: false },
      { text: "Систолическое", value: "pressuresys", align: "start", sortable: false },
      { text: "Диастолические", value: "pressuredia", align: "start", sortable: false },
      { text: "Этанол", value: "ethanol", align: "start", sortable: false },
      { text: "Подписан", value: "doctor_sign", sortable: false },
      //   { text: "Результат", value: "result", align: "start", sortable: false },
    ],

    items: [],
    meta: { total: 0 },
  }),

  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
    doctorId() {
      return this.$store.state.auth.id;
    },
  },

  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },

  async mounted() {
    this.$echo
      .private("customer-documents")
      .listen(".customer-document-add", payload => {
        this.load();
      })
      .listen(".customer-document-updated", payload => {
        this.load();
      });
  },

  destroyed() {
    this.$echo
      .private("customer-documents")
      .stopListening(".customer-document-add")
      .stopListening(".customer-document-updated");
  },

  methods: {
    async load() {
      this.loading = true;

      const params = {
        ...QueryHelper.tableSorting(this.options),
        ...QueryHelper.pagination(this.options, this.meta.total),
      };

      try {
        const response = await this.$http.get(`v1/automated-pre-trip-inspection`, { params }).then(r => r.data);
        this.items = response.data;
        this.meta.total = response.meta.total;
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);
        this.meta.total = 0;
      }

      this.loading = false;
    },

    // Открываем модалку с документом
    async onRowClick(doc) {
      if (this.loading) {
        return;
      }

      try {
        this.loading = true;
        const r = await CustomerService.getDocument(doc.employee.id, doc.id);
        this.loading = false;

        const isUpdated = await this.$dialog.showAndWait(AddDocument, {
          customerForm: r,
          employeeId: doc.employee.id,
          readonly: !!r.doctor_sign,
          width: 600,
          doctorId: this.doctorId,
          persistent: true,
        });

        if (isUpdated) {
          this.load();
        }
      } catch (e) {
        if (e?.response.status === 404) {
          this.$dialog.notify.error(`Документ №${doc.id} не найден`);
        } else {
          this.$dialog.notify.error("Не удалось загрузить документ");
        }
      }
    },

    async signItem(item) {
      try {
        const r = await CustomerService.getDocument(item.employee.id, item.id);
        const isUpdated = await this.$dialog.showAndWait(SignDocument, {
          customerForm: r,
          readonly:
            !!r.doctor_sign ||
            (this.doctorId !== r.author.id && !this.$featureFlags.feature(FLAGS.DISABLE_CHECK_DOCUMENT_AUTHOR).enabled),
          width: 600,
          persistent: true,
        });

        if (isUpdated) {
          this.load();
        }
      } catch (e) {
        console.log(`e =>`, e);
        if (e?.response.status === 404) {
          this.$dialog.notify.error(`Документ №${item.id} не найден`);
        } else {
          this.$dialog.notify.error("Не удалось загрузить документ");
        }
      }
    },

    async allowToWork(item) {
      console.log("item", item);
      try {
        const { data } = await this.$http.post(`v1/customers/${item.employee.id}/documents/${item.id}/allow-to-work`);
        if (data?.success) {
          this.$dialog.notify.success("Сотрудник получил допуск на работу");
          await this.load();
        } else {
          this.$dialog.notify.warning(data?.message || "Ошибка");
        }
      } catch (e) {
        console.error(e);
        this.$dialog.notify.error("Не удалось отправить запрос");
      }
    },

    /**
     * @param {Array} files
     */
    buildPreviewUrls(files) {
      if (!files) {
        return [];
      }

      return files
        .filter(file => imageExtList.includes(file.extension))
        .map(file => {
          return { ...file, path: buildDocumentUrl(this.customerId, file.id) };
        });
    },
  },
};
</script>

<style scoped></style>
